





























































import { ConfigurationEntry } from "@/model/communication/application/GetServerConfigurationResponse";
import { RootState } from "@/store";
import { ApplicationState } from "@/store/modules/ApplicationModule";
import Vue from "vue";
import { mapActions, mapState } from "vuex";

import Password from "vue-password-strength-meter";
import Footer from "@/views/App/Components/Footer.vue";

import { ResetPasswordCommand } from "@/model/communication/auth/ResetPasswordCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GET_SERVER_CONFIGURATION } from "@/store/modules/ApplicationModule/actions";

const minScoreKey: string = "minScore";
const minCharactersKey: string = "minCharacters";
const differentPwKey: string = "differentPw";

const defaultMinScore: number = 3;
const defaultMinCharacters: number = 8;
const defaultDifferentPw: number = -1;

export default Vue.extend({
    components: { Password, Footer },
    data() {
        return {
            passwordTyped1: null,
            passwordTyped2: null,
            currentScore: 0,
            suggestions: null,
            warning: null,
            loading: false,
            showPassword: false,
            showErrorAlert: false,
            errorAlertMessage: null,
            resetPasswordLoading: false,
            showAlert: false,
            invalidToken: false,
        };
    },
    computed: {
        ...mapState({
            passwordPolicy: function (state: RootState): ConfigurationEntry[] {
                return (state.application as ApplicationState).configurationEntries.filter((c) => c.section == "PASSWORD_POLICY");
            },
        }),

        minScoreRequired() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == minScoreKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultMinScore;
            } catch (error) {
                console.error("Cannot read ", minScoreKey, " value from server pw policy configuration. Set it to ", defaultMinScore, " as default.");
                return defaultMinScore;
            }
        },

        secureLength() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == minCharactersKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultMinCharacters;
            } catch (error) {
                console.error("Cannot read ", minCharactersKey, " value from server pw policy configuration. Set it to ", defaultMinCharacters, " as default.");
                return defaultMinCharacters;
            }
        },

        differentPw() {
            try {
                var value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == differentPwKey) as ConfigurationEntry).value);
                return value >= 0 ? value : defaultDifferentPw;
            } catch (error) {
                console.error("Cannot read ", differentPwKey, " value from server pw policy configuration.");
                return defaultDifferentPw;
            }
        },

        samePassword() {
            return this.passwordTyped1 != null && this.passwordTyped2 != null && this.passwordTyped1.length > 0 && this.passwordTyped2 == this.passwordTyped1;
        },

        submitAvailable() {
            // return true;
            if (this.minScoreRequired == undefined) return false;
            return this.samePassword && this.currentScore >= this.minScoreRequired && this.passwordTyped1.length >= this.secureLength;
        },

        forgotPasswordUsername() {
            return this.$route.query.user;
        },
        forgotPasswordToken() {
            return this.$route.query.token;
        },
        loginStyle() {
            if (this.$vuetify.breakpoint.smAndUp) return "border: thin solid rgba(0, 0, 0, 0.12); border-radius: 8px; padding: 48px 40px 40px 40px; background-color:white";
            return "";
        },
    },
    methods: {
        ...mapActions(["GET_SERVER_CONFIGURATION"]),
        async resetPassword() {
            this.resetPasswordLoading = true;
            try {
                var res = await new ResetPasswordCommand(this.forgotPasswordUsername, this.forgotPasswordToken, this.passwordTyped1).execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                    this.showAlert = true;
                } else {
                    if (res.message == "InvalidRequest") this.invalidToken = true;
                    else {
                        this.showErrorAlert = true;
                        if (res.message == "Too many request") this.errorAlertMessage = this.$t("login.wait5seconds");
                        else this.errorAlertMessage = this.$t("login.same_pw") + " " + (this.differentPw >= 0 ? this.differentPw : "");
                    }
                }
            } catch (exc) {
                console.error("Something went wrong while sending ResetPassword request");
                this.showErrorAlert = true;
                this.errorAlertMessage = this.$t("login.genericErrorResetPassword");
            }

            this.resetPasswordLoading = false;
        },
        onFeedbackChange({ suggestions, warning }) {
            this.suggestions = suggestions;
            this.warning = warning;
        },

        onScoreChange(score) {
            this.currentScore = score;
        },

        reset() {
            this.passwordTyped1 = null;
            this.passwordTyped2 = null;
            this.currentScore = 0;
            this.suggestions = null;
            this.warning = null;
            this.loading = false;
            this.showPassword = false;
            this.showErrorAlert = false;
        },
    },
    mounted() {
        this[GET_SERVER_CONFIGURATION]();
    },
});
